export default __webpack_public_path__ + "static/media/promo-undesirable-no-1_01.89116216.jpg";